import { useLocalizedNavigate } from '../../../hooks/useLocalizedNavigate';
import { useAppSelector } from '../../../store/hooks';
import { User } from '../../../utils/types';
import { Button, TextField, Title, UserAvatar } from '../../common';

import './followersDialog.css';

interface FollowersDialogProps {
    isOpen: boolean;
    followers: User[];
    isLoading: boolean;
    onClose: () => void;
    followUser: (userId: string) => void;
}

export const FollowersDialog = ({
    isOpen,
    followers,
    isLoading,
    onClose,
    followUser,
}: FollowersDialogProps) => {
    const auth = useAppSelector(state => state.auth);
    const navigate = useLocalizedNavigate();

    if (!isOpen) {
        return null;
    }

    const userClickHandler = (userId: string) => {
        onClose();
        navigate(`/users/${userId}`);
    };

    return (
        <div className="dialog-overlay">
            <div className="followers-dialog-container">
                <div className="dialog-header">
                    <Title text="Followers"></Title>
                </div>
                <div className="followers-dialog-body">
                    <div className="followers">
                        {followers.map(follower => {
                            return (
                                <div
                                    key={follower.id}
                                    className="follower-wrapper"
                                >
                                    <div className="follower-details">
                                        <UserAvatar
                                            imageSrc={follower.avatarUrl}
                                            size="l"
                                            onClick={() =>
                                                userClickHandler(follower.id)
                                            }
                                        />
                                        <TextField>
                                            {follower.username}
                                        </TextField>
                                    </div>
                                    {!follower.isFollowing &&
                                        follower.id !== auth.authData?.id && (
                                            <Button
                                                text="Follow"
                                                size="sm"
                                                onClick={() =>
                                                    followUser(follower.id)
                                                }
                                            />
                                        )}
                                    {follower.isFollowing && (
                                        <Button
                                            text="Followed"
                                            variant="green"
                                            size="sm"
                                            onClick={() =>
                                                followUser(follower.id)
                                            }
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="dialog-footer">
                    <Button
                        type="button"
                        text="Close"
                        variant="transparent"
                        onClick={onClose}
                        size="md"
                        disabled={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};
